import React from 'react';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { Visible } from 'components';

interface IProps {
  url?: string;
  text: string;
  image: string;
  color?: string;
  bgColor: string;
  isSoon?: boolean;
  hoverColor?: string;
  imageWidth?: number;
  imageHeight?: number;
  isHorizontal?: boolean;
  hasHoverEffect?: boolean;
  extraSection?: React.ReactNode;
}

const BlokMainCards: React.FC<IProps> = ({
  url,
  text,
  image,
  color,
  bgColor,
  hoverColor,
  extraSection,
  imageWidth = 200,
  imageHeight = 200,
  isSoon = false,
  isHorizontal = false,
  hasHoverEffect = true
}) => {
  const t = useTranslations();

  const cardContent = isHorizontal ? (
    <div
      className={cn(
        'h-50 group relative flex flex-col items-start justify-start overflow-hidden rounded-xl pt-4',
        bgColor,
        {
          'pl-4 pr-0': text === t('home.banner.DTMtest'),
          'px-4': text !== t('home.banner.DTMtest')
        }
      )}
    >
      {isSoon && (
        <div className="z-11 absolute inset-0 flex cursor-pointer flex-col items-center justify-center rounded-2xl bg-white/70 backdrop-blur-[3px] transition hover:bg-white/80">
          <span className="text-sm font-medium text-gray-500">{t('tez_kunda')}</span>
        </div>
      )}
      {hasHoverEffect && (
        <div className="-bottom-55 absolute -right-40 flex items-center justify-center">
          <div
            className="h-120 w-120 duration-400 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
            style={{ backgroundColor: `${hoverColor}33` }}
          >
            <div
              className="duration-400 h-76 w-76 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${hoverColor}66` }}
            >
              <div
                className="h-50 w-50 duration-400 z-0 rounded-full transition-transform group-hover:scale-110"
                style={{ backgroundColor: `${hoverColor}` }}
              />
            </div>
          </div>
        </div>
      )}

      <div className="z-10 flex flex-col items-start">
        <p className={`font-bold ${color} z-10 mt-3 text-2xl`}>{text?.toUpperCase()}</p>
        {extraSection}
      </div>

      <div className="relative flex h-full w-full items-center justify-center">
        <Image
          src={image}
          alt={text}
          width={imageWidth}
          height={imageHeight}
          title="blok-testlarni tasvirlovchi rasm"
          className={`absolute bottom-0 ${text === t('virtual_imtihon') ? '-right-10' : 'right-0'} rounded-tr-xl`}
        />
      </div>
    </div>
  ) : (
    <div
      className={cn(
        'h-82 group relative flex flex-col items-center justify-start overflow-hidden rounded-xl pt-4',
        bgColor,
        {
          'pl-4 pr-0': text === t('home.banner.DTMtest'),
          'px-4': text !== t('home.banner.DTMtest')
        }
      )}
    >
      <div className="absolute -bottom-40 flex items-center justify-center">
        <div
          className="h-102 w-102 duration-400 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
          style={{ backgroundColor: `${hoverColor}33` }}
        >
          <div
            className="duration-400 h-76 w-76 z-0 flex items-center justify-center rounded-full transition-transform group-hover:scale-110"
            style={{ backgroundColor: `${hoverColor}66` }}
          >
            <div
              className="h-50 w-50 duration-400 z-0 rounded-full transition-transform group-hover:scale-110"
              style={{ backgroundColor: `${hoverColor}` }}
            />
          </div>
        </div>
      </div>

      <div className="z-10 flex flex-col items-center  justify-center">
        <p className={`font-semibold ${color} z-10 mt-3 text-center text-xl`}>{text}</p>
        {text === t('home.banner.DTMtest') && <div className="mt-1 rounded-md bg-blue-600 px-2 text-white">2025</div>}
      </div>

      <div className="relative flex h-full w-full items-center justify-center">
        <Image
          src={image}
          alt={text}
          width={300}
          height={300}
          title="blok-testlarni tasvirlovchi rasm"
          className="absolute bottom-0 rounded-tr-xl"
        />
      </div>
    </div>
  );

  return (
    <Visible if={url} else={cardContent}>
      <Link href={url as string}>{cardContent}</Link>
    </Visible>
  );
};

export default BlokMainCards;
